const swatchSwit = {
    tagUrl: "//eu4-track.inside-graph.com/gtm/IN-1000980/include.js",
    logo: "/assets/swatch-logo.svg"
}

export default swatchSwit;